import React, { FC, forwardRef, useEffect, useState } from 'react';
import PtPlanDialog from './ptPlanDialog';
import { DriftThemeProvider, Dialog, DialogContent, CloseIcon, IconButton } from 'drift-ui';
import { useSelector } from 'react-redux';
import { getIsSideNavigationCollapsed } from '../../../redux/actions/appActions';
import Slide, { SlideProps } from '@mui/material/Slide';
import PtEnterPayment from './ptEnterPayment';
import PtSuccessComponent from './ptSuccessComponent';

interface PtSubscriptionModalModalProps {
  open: boolean;
  sideNavWidth?: number;
  onClose: () => void;
}

const Transition = forwardRef(function Transition(props: SlideProps, ref) {
  return <Slide direction="up" ref={ref} {...props} />;
});

export const PtSubscriptionModal: FC<PtSubscriptionModalModalProps> = ({ open, onClose, sideNavWidth }) => {
  const isCollapsed = useSelector(getIsSideNavigationCollapsed);
  const [isInitialized, setIsInitialized] = useState(false);
  const [currentStep, setCurrentStep] = useState(0);
  const [isMonthly, setIsMonthly] = useState(true);
  const [middleSlideDirection, setMiddleSlideDirection] = useState<'left' | 'right'>('left');
  const stepContainerStyle: any = {
    position: 'absolute',
    width: 'calc(100% - 60px)',
    minWidth: '940px',
    height: 'calc(100vh - 95px)',
    maxHeight: '960px',
    padding: '15px 30px',
    overflow: 'auto',
  };

  useEffect(() => {
    setIsInitialized(true);
  }, []);

  const handleNext = () => {
    if (currentStep === 1) {
      setMiddleSlideDirection('right');
    }
    setCurrentStep((prevStep) => prevStep + 1);
  };
  const handleBack = () => {
    setCurrentStep((prevStep) => prevStep - 1);
  };

  return (
    <DriftThemeProvider>
      <Dialog
        keepMounted
        open={open}
        maxWidth={false}
        TransitionComponent={Transition}
        sx={{
          '& .MuiDialog-container': {
            marginLeft: isCollapsed ? '70px' : '170px',
          },
          '& .MuiDialog-paper': {
            width: `min(1180px, calc(100vw - ${(sideNavWidth ?? 0) + 16}px))`,
            height: 'calc(100vh - 44px)',
            maxHeight: '975px',
            overflowY: 'hidden',
          },
          '& .MuiDialogContent-root': {
            padding: '0',
          },
        }}
        onClose={onClose}
      >
        <DialogContent>
          <IconButton
            aria-label="close"
            onClick={onClose}
            sx={{
              position: 'absolute',
              right: 25,
              top: 45,
              height: '32px',
              width: '32px',
              color: '#000',
              zIndex: 1,
            }}
          >
            <CloseIcon />
          </IconButton>
          <Slide
            easing="linear"
            direction="right"
            in={currentStep === 0}
            timeout={isInitialized ? 400 : 0}
            mountOnEnter
            unmountOnExit
          >
            <div style={stepContainerStyle}>
              <PtPlanDialog handleNext={handleNext} isMonthly={isMonthly} setIsMonthly={setIsMonthly} />
            </div>
          </Slide>
          <Slide
            easing="linear"
            direction={middleSlideDirection}
            in={currentStep === 1}
            timeout={400}
            mountOnEnter
            unmountOnExit
          >
            <div style={stepContainerStyle}>
              <PtEnterPayment
                handleNext={handleNext}
                handleBack={handleBack}
                isMonthly={isMonthly}
                setIsMonthly={setIsMonthly}
              />
            </div>
          </Slide>
          <Slide easing="linear" direction="left" in={currentStep === 2} timeout={400} mountOnEnter unmountOnExit>
            <div style={stepContainerStyle}>
              <PtSuccessComponent />
            </div>
          </Slide>
        </DialogContent>
      </Dialog>
    </DriftThemeProvider>
  );
};
